export const routerPath = {
  root: '/dubai3030-report',
};

export const generateHTMLReport = (data) => `<!DOCTYPE html>
<html>
<head>
    <title>DUBAI FITNESS CHALLENGE</title>
    <style>
       body, html {
            height: 100%;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
        }
        
        body {
            font-family: Arial, sans-serif;
            background: linear-gradient(151deg, rgba(12,194,187,1) 0%, rgba(5,110,183,1) 41%);
          
        }
        
        .wrapper {
         width: 880px;
        }

        .header {
            padding: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .title {
            margin-left: 20px;
            font-size: 20px;
            color: #ffffff;
        }

        .icon {
           
         
        }

        .content {
            display: flex;
            justify-content: center;
            gap: 60px;
        }

        .column {
            width: 400px;  
            display: flex;
            flex-direction: column;
            gap: 20px;
        }

        .table {
            border-collapse: collapse;
            width: 100%;
        }

        .table th, .table td {
            border: 1px solid #ffffff;
            padding: 8px;
            text-align: center;
            color: #ffffff;
            height: 15px;
            font-weight: 400;
            font-size: 13px;
        }
        
        .table caption {
            font-size: 15px;
            background-color: #2c8bc1;
            color: #ffffff;
            padding: 10px;
            border: 1px solid #fff;
            border-bottom: 0;
            font-weight: 700;
        }
    </style>
</head>
<body>
    <div class="wrapper">
    <div class="header">
        <h1 class="title">DUBAI FITNESS CHALLENGE 2023</h1>
        <div class="icon">
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
     width="100pt" height="45pt" viewBox="0 0 834.000000 396.000000"
     preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,396.000000) scale(0.100000,-0.100000)"
       fill="white" stroke="none">
        <path d="M4568 3320 c-167 -28 -271 -114 -316 -260 -14 -48 -17 -109 -17 -470
0 -307 4 -430 13 -473 26 -112 120 -214 236 -254 39 -14 82 -18 186 -18 131 0
137 1 201 31 123 58 187 140 209 265 8 44 10 201 8 485 l-3 419 -28 61 c-77
166 -271 250 -489 214z m136 -262 c14 -20 16 -80 15 -468 -1 -245 -4 -456 -8
-469 -3 -13 -14 -29 -22 -34 -21 -13 -65 -1 -74 20 -11 26 -19 688 -10 827 8
125 16 146 60 146 13 0 31 -10 39 -22z"/>
        <path d="M766 3305 c-148 -41 -309 -172 -374 -306 -63 -130 -62 -114 -62 -986
0 -533 4 -809 11 -845 20 -96 83 -212 157 -287 73 -74 130 -111 231 -150 l66
-26 810 -3 c576 -2 830 1 878 9 215 36 422 237 467 453 7 35 10 314 8 876 l-3
825 -22 59 c-54 142 -158 265 -280 329 -133 70 -96 67 -1013 66 -657 -1 -835
-4 -874 -14z m629 -735 l170 -170 -145 -145 -145 -145 -292 292 c-161 161
-293 301 -293 310 0 36 27 39 285 34 l249 -5 171 -171z m1215 162 c18 -15 21
-22 12 -38 -6 -10 -139 -147 -296 -304 l-286 -285 -147 148 -148 147 170 170
169 169 81 4 c44 1 157 4 251 5 153 2 174 0 194 -16z m-660 -1103 l0 -387 -31
-27 -32 -26 -239 3 -240 3 -24 28 -24 28 0 387 -1 387 148 142 148 142 148
-147 147 -147 0 -386z"/>
        <path d="M3305 3288 c2 -7 63 -218 135 -470 l130 -456 0 -246 0 -246 170 0
170 0 0 256 0 256 135 454 c74 250 135 456 135 459 0 3 -76 5 -170 5 l-169 0
-10 -37 c-8 -31 -38 -188 -87 -458 -7 -38 -8 -36 -20 45 -7 47 -27 167 -45
268 l-32 182 -173 0 c-134 0 -172 -3 -169 -12z"/>
        <path d="M5230 2725 c0 -375 4 -592 11 -625 22 -103 115 -196 236 -236 45 -15
87 -19 193 -19 130 0 137 1 201 31 83 40 133 90 173 173 l31 66 3 593 4 592
-191 0 -191 0 0 -582 c0 -321 -3 -593 -6 -606 -9 -34 -53 -41 -76 -12 -17 21
-18 55 -18 611 l0 589 -185 0 -185 0 0 -575z"/>
        <path d="M6220 2587 l0 -717 185 0 185 0 0 320 0 320 30 0 c19 0 40 -9 55 -25
l25 -24 0 -296 0 -295 176 0 175 0 -3 299 -3 299 -30 44 c-22 31 -48 52 -95
75 -56 28 -61 33 -36 33 16 0 49 9 72 21 63 30 85 82 92 217 12 254 -60 389
-223 422 -27 5 -175 13 -327 16 l-278 7 0 -716z m455 438 c23 -23 25 -31 25
-130 0 -59 -5 -115 -10 -125 -10 -19 -76 -44 -92 -34 -4 3 -8 75 -8 160 l0
154 30 0 c19 0 40 -9 55 -25z"/>
        <path d="M7290 3160 l0 -90 130 0 130 0 0 -25 0 -25 -130 0 -130 0 0 -95 0
-95 355 0 355 0 0 95 0 95 -150 0 -150 0 0 25 0 25 150 0 150 0 0 90 0 90
-355 0 -355 0 0 -90z"/>
        <path d="M7418 2761 c-85 -17 -129 -77 -136 -187 -3 -55 0 -86 12 -119 18 -47
72 -101 110 -111 12 -3 128 -4 257 -2 275 4 285 6 325 91 35 75 34 167 -4 237
-36 69 -73 89 -186 97 l-86 6 0 -92 0 -91 48 -1 c80 -1 126 -12 130 -33 2 -10
-2 -22 -10 -27 -7 -5 -112 -9 -233 -9 -121 0 -226 4 -233 9 -8 5 -12 17 -10
27 4 23 38 31 131 33 l67 1 0 90 0 90 -72 -1 c-40 -1 -89 -5 -110 -8z"/>
        <path d="M7623 2257 l-333 -51 0 -133 c0 -73 3 -133 6 -133 3 0 158 -20 344
-45 186 -25 344 -45 349 -45 7 0 11 35 11 95 l0 95 -34 0 c-18 0 -48 3 -65 6
-26 5 -31 11 -31 34 0 33 14 40 81 40 l49 0 0 95 c0 92 -1 95 -22 94 -13 -1
-173 -24 -355 -52z m125 -180 c3 -22 -1 -27 -20 -27 -47 0 -228 24 -228 30 0
6 211 28 235 25 6 -1 11 -14 13 -28z"/>
        <path d="M7385 1801 c-22 -10 -48 -27 -57 -37 -67 -76 -62 -253 8 -316 48 -43
84 -48 311 -48 190 0 223 3 258 19 72 33 105 93 105 191 0 98 -33 158 -105
191 -35 16 -68 19 -260 19 -192 0 -225 -3 -260 -19z m489 -167 c24 -9 19 -41
-6 -48 -40 -10 -428 -7 -449 4 -22 12 -25 36 -6 43 18 8 442 8 461 1z"/>
        <path d="M5991 1707 c-19 -6 -54 -29 -77 -51 -53 -52 -67 -102 -62 -221 5
-120 30 -165 131 -235 201 -140 197 -135 197 -230 0 -49 -4 -61 -22 -74 -28
-20 -33 -20 -52 0 -12 12 -16 37 -16 105 l0 89 -115 0 -115 0 0 -87 c0 -146
27 -200 124 -251 46 -24 62 -26 156 -27 90 0 113 4 158 24 101 45 127 104 120
271 -4 81 -9 114 -26 146 -26 50 -94 112 -182 165 -97 58 -110 71 -120 114
-14 63 4 115 41 115 26 0 39 -31 39 -94 l0 -56 115 0 115 0 0 68 c0 37 -5 85
-11 107 -15 53 -68 101 -131 120 -60 17 -215 19 -267 2z"/>
        <path d="M6610 1699 c-93 -42 -121 -88 -128 -209 -6 -109 14 -186 61 -232 18
-18 80 -66 138 -106 59 -40 111 -84 117 -98 7 -14 12 -52 12 -84 0 -53 -3 -61
-26 -77 -26 -16 -27 -16 -45 6 -15 19 -19 40 -19 107 l0 84 -116 0 -117 0 5
-107 c5 -114 16 -150 60 -189 96 -88 303 -99 419 -22 58 39 79 96 79 211 0
142 -12 181 -79 248 -31 30 -88 74 -127 97 -102 61 -126 89 -127 150 -1 54 14
82 44 82 26 0 39 -31 39 -94 l0 -56 115 0 115 0 0 68 c0 91 -16 141 -56 178
-49 46 -111 64 -223 64 -75 0 -106 -5 -141 -21z"/>
        <path d="M3300 1220 l0 -480 125 0 125 0 0 200 0 200 80 0 80 0 0 95 0 95 -80
0 -80 0 0 90 0 90 90 0 90 0 0 95 0 95 -215 0 -215 0 0 -480z"/>
        <path d="M3790 1220 l0 -480 125 0 125 0 0 480 0 480 -125 0 -125 0 0 -480z"/>
        <path d="M4100 1605 l0 -95 75 0 75 0 0 -385 0 -385 125 0 125 0 0 385 0 385
75 0 75 0 0 95 0 95 -275 0 -275 0 0 -95z"/>
        <path d="M4700 1220 l0 -480 105 0 105 0 2 212 3 212 43 -144 c24 -80 52 -175
64 -212 l20 -68 109 0 109 0 0 480 0 480 -105 0 -105 0 -1 -202 -1 -203 -66
203 -66 202 -108 0 -108 0 0 -480z"/>
        <path d="M5360 1220 l0 -480 220 0 220 0 0 95 0 94 -92 3 -93 3 -3 103 -3 102
81 0 80 0 0 95 0 95 -80 0 -80 0 0 90 0 90 85 0 85 0 0 95 0 95 -210 0 -210 0
0 -480z"/>
        <path d="M7418 1331 c-85 -17 -129 -77 -136 -187 -8 -121 45 -213 131 -229 18
-4 134 -5 257 -3 203 3 228 5 258 23 80 48 108 199 56 303 -36 73 -72 92 -184
99 l-90 6 0 -92 0 -91 63 -1 c34 -1 73 -4 87 -8 28 -8 39 -39 18 -52 -17 -11
-449 -11 -466 0 -21 13 -10 44 18 52 14 4 58 7 98 8 l72 1 0 90 0 90 -72 -1
c-40 -1 -89 -5 -110 -8z"/>
        <path d="M7850 795 l0 -65 75 0 75 0 0 65 0 65 -75 0 -75 0 0 -65z"/>
    </g>
</svg>
</div>
    </div>
    <div class="content">
        <div class="column">
            <table class="table">
                <caption>Participation</caption>
                <tr>
                    <th></th>
                    <th>Entered</th>
                    <th>Active</th>
                    <th>Active %</th>
                </tr>
                <tr>
                    <td>Male</td>
                    <td>${data.totalPopulationBreakDown.male.total}</td>
                    <td>${data.totalPopulationBreakDown.male.act}</td>
                    <td>${data.totalPopulationBreakDown.male.actPer}</td>
                </tr>
                  <tr>
                    <td>Female</td>
                    <td>${data.totalPopulationBreakDown.female.total}</td>
                    <td>${data.totalPopulationBreakDown.female.act}</td>
                    <td>${data.totalPopulationBreakDown.female.actPer}</td>
                </tr>
                 <tr>
                    <td>Other</td>
                    <td>${data.totalPopulationBreakDown.other.total}</td>
                    <td>${data.totalPopulationBreakDown.other.act}</td>
                    <td>${data.totalPopulationBreakDown.other.actPer}</td>
                </tr>
                <tr>
                    <td>Total</td>
                    <td>${data.totalPopulationBreakDown.allGenders.total}</td>
                    <td>${data.totalPopulationBreakDown.allGenders.act}</td>
                    <td>${data.totalPopulationBreakDown.allGenders.actPer}</td>
                </tr>
            </table>
            <table class="table">
                <caption>STEPS/AGE GROUP</caption>
                <tr>
                    <th style="width: 150px"></th>
                    <th style="width: 300px">Total</th>
                    <th style="width: 150px">Per Day</th>
                </tr>
                <tr>
                    <td>18-25</td>
                    <td>${data.steps.first.total}</td>
                    <td>${data.steps.first.perDay}</td>
                </tr>
                  <tr>
                    <td>26-35</td>
                    <td>${data.steps.second.total}</td>
                    <td>${data.steps.second.perDay}</td>
                </tr>
                <tr>
                    <td>36-45</td>
                    <td>${data.steps.third.total}</td>
                    <td>${data.steps.third.perDay}</td>
                </tr>
                <tr>
                    <td>46+</td>
                    <td>${data.steps.forth.total}</td>
                    <td>${data.steps.forth.perDay}</td>
                </tr>
            </table>
             <table class="table">
                <caption>STEPS TOTAL</caption>
                <tr>
                    <th style="width: 50%;">Total</th>
                    <th >Per Day</th>
                </tr>
                <tr>
                    <td>${data.stepsTotal.total}</td>
                    <td>${data.stepsTotal.totalPerDay}</td>
                </tr>
            </table>
            <table class="table">
                <caption>INDIVIDUAL CALORIE TOTAL</caption>
                <tr>
                    <th style="width: 50%;">Total</th>
                    <th >Per Day</th>
                </tr>
                <tr>
                    <td>${data.stepsIndividualAverage.total}</td>
                    <td>${data.stepsIndividualAverage.totalPerDay}</td>
                </tr>
            </table>
        </div>
         <div class="column">
            <table class="table">
                <caption>Age Group</caption>
                <tr>
                    <th></th>
                    <th>Entered</th>
                    <th>Active</th>
                    <th>Active %</th>
                </tr>
                <tr>
                    <td>18-25</td>
                    <td>${data.ageGroup.first.total}</td>
                    <td >${data.ageGroup.first.act}</td>
                    <td>${data.ageGroup.first.actPer}</td>
                </tr>
                  <tr>
                    <td>26-35</td>
                    <td>${data.ageGroup.second.total}</td>
                    <td>${data.ageGroup.second.act}</td>
                   <td>${data.ageGroup.second.actPer}</td>
                </tr>
                <tr>
                    <td>36-45</td>
                    <td>${data.ageGroup.third.total}</td>
                    <td>${data.ageGroup.third.act}</td>
                    <td>${data.ageGroup.third.actPer}</td>
                </tr>
                <tr>
                    <td>46+</td>
                     <td>${data.ageGroup.forth.total}</td>
                    <td>${data.ageGroup.forth.act}</td>
                    <td>${data.ageGroup.forth.actPer}</td>
                </tr>
            </table>
            <table class="table">
                <caption>CALORIE BURN/AGE GROUP</caption>
                <tr>
                    <th style="width: 150px"></th>
                    <th style="width: 300px">Total</th>
                    <th style="width: 150px">Per Day</th>
                </tr>
                <tr>
                    <td>18-25</td>
                    <td>${data.calories.first.total}</td>
                    <td>${data.calories.first.perDay}</td>
                </tr>
                  <tr>
                    <td>26-35</td>
                    <td>${data.calories.second.total}</td>
                    <td>${data.calories.second.perDay}</td>
                </tr>
                <tr>
                    <td>36-45</td>
                    <td>${data.calories.third.total}</td>
                    <td>${data.calories.third.perDay}</td>
                </tr>
                <tr>
                    <td>46+</td>
                    <td>${data.calories.forth.total}</td>
                    <td>${data.calories.forth.perDay}</td>
                </tr>
            </table>
             <table class="table">
                <caption>GROUP CALORIE TOTAL</caption>
                <tr>
                    <th style="width: 50%;">Total</th>
                    <th >Per Day</th>
                </tr>
                <tr>
                    <td>${data.caloriesTotal.total}</td>
                    <td>${data.caloriesTotal.perDay}</td>
                </tr>
            </table>
            <table class="table">
                <caption>INDIVIDUAL CALORIE TOTAL</caption>
                <tr>
                    <th style="width: 50%;">Total</th>
                    <th >Per Day</th>
                </tr>
                <tr>
                    <td>${data.caloriesIndividualAverage.total}</td>
                    <td>${data.caloriesIndividualAverage.perDay}</td>
                </tr>
            </table>
        </div>
    </div>
    </div>
</body>
</html>
`;
